module.exports = __webpack_public_path__ + "img/discord_circular.fc7944e8.svg";